import { render, staticRenderFns } from "./PanelGate.vue?vue&type=template&id=24001994&"
import script from "./PanelGate.vue?vue&type=script&lang=js&"
export * from "./PanelGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports